require('./insuranceRequestWizardRequestSuccess.scss');
require('./insuranceRequestWizardRequestSuccess.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const OKModal = require('components/commons/OKModal/OKModal');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ helpers
const { base64ToBlob } = require('utilities/APIRequestHelper');
const { download } = require('utilities/fileDownloadHelper');

// @ components
const InsuranceRequestPolicySummary = require('../insuranceRequestPolicySummary/insuranceRequestPolicySummary');

// @ constants
const { DOCUMENT_TYPES: { POLICY } } = require('../../../insuranceConstants/insuranceRequestHome');

// @ utils
const { recordLinkV2 } = require("utilities/tagging");
class insuranceRequestWizardRequestSuccess extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.handleDownloadPolicy = this.handleDownloadPolicy.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    componentWillMount() {
        const { getDocument } = this.props;
        const documentName = formatText('insuranceRequestHome-confirmationPolicy');
        getDocument(POLICY, documentName);
    }

    componentDidMount() {
        const tealiumDataLink = {
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "confirmation",
        };
        recordLinkV2(tealiumDataLink);
    }

    handleDownloadPolicy() {
        const { policyPdfBase64, policyPdfName, policyPdfType } = this.props;
        download(base64ToBlob(policyPdfBase64), policyPdfName, policyPdfType);
    }

    handleToggleModal() {
        this.setState(previousState => ({ showModal: !previousState.showModal }));
    }

    buildPdfViewer(isModal = false) {
        const { policyPdfBase64 } = this.props;
        let onDownload;
        let onFullScreen;
        let scalePdfViewer;
        let height;

        if (isModal) {
            height = ' ';
            scalePdfViewer = 1.25;
        } else {
            onDownload = this.handleDownloadPolicy;
            onFullScreen = this.handleToggleModal;
            scalePdfViewer = 1.05;
        }

        return (
            <OKPdfViewer
                pdfFile={policyPdfBase64}
                title={formatText('insuranceRequestHome-step5InsuranceHomePDF')}
                scale={scalePdfViewer}
                onDownload={onDownload}
                onFullScreen={onFullScreen}
                viewerHeight={height}
            />
        );
    }

    buildContactCenterMandatoryReading() {
        const { isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHomeCC';
        const message = isRelated
            ? `${poeditorPrefix}-${poeditorPrefix}_relatedMandatoryReadingStepSuccess`
            : `${poeditorPrefix}-${poeditorPrefix}_mandatoryReadingStepSuccess`;

        return __CONTACT_CENTER__
            ? (
                <BlockInfo
                    extraClass={'insurance-request-wizard-request-success__block-info'}>
                    {formatText(message)}
                </BlockInfo>
            )
            : null;
    }

    buildSuccessInfoMessage() {
        return (
            <OKMessage type="informative">
                <FormattedText value="insuranceRequestHome-step5InsuranceText" />
            </OKMessage>
        );
    }

    render() {
        const {
            isRelated,
            immInsuranceState,
            immInsuranceWizardState,
            immAccounts,
            hasSimulation,
            hasSimulationChanged,
            productName,
        } = this.props;

        const title = formatText('insuranceRequestHome-step5TitleInsuranceSuccess');

        const mainButton = {
            url: formatText('insuranceRequestHome-step5GoToInsurancesLinkURL'),
            label: formatText('insuranceRequestHome-step5GoToInsurancesLink')
        };
        const modalContent = (
            <section className="insurance-request-wizard-request-success__pdf-modal">
                {this.buildPdfViewer(true)}
            </section>
        );
        const ccMandatoryReading = this.buildContactCenterMandatoryReading();
        const successInfoMessage = !__CONTACT_CENTER__ ? this.buildSuccessInfoMessage() : null;
        const sectionClass = classnames('insurance-request-wizard-request-success__summary', {
            'insurance-request-wizard-request-success__summary-cc': __CONTACT_CENTER__
        });
        const tealiumData = {
            event_name: "step_success",
            pageName: "/homeInsurancesContracting/success",
            sectionFamily: "banking",
            sectionCategory: "products",
            sectionName: "insurances",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType: "homeInsurancesContracting",
            processStep: "success",
            productName: productName,
        };
        return (
            <div className="col-md-10 col-md-offset-1">
                <div className="insurance-request-wizard-request-success">
                    <WizardSuccess
                        mainButton={mainButton}
                        successMessage={title}
                        customClassName="insurance-request-wizard-request-success__wizard"
                        tealium={tealiumData}
                        isSecondVersion
                    >
                        {ccMandatoryReading}
                        {successInfoMessage}
                        <section className={sectionClass}>
                            <InsuranceRequestPolicySummary
                                isRelated={isRelated}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardState={immInsuranceWizardState}
                                immAccounts={immAccounts}
                                hasSimulation={hasSimulation}
                                hasSimulationChanged={hasSimulationChanged}
                            />
                        </section>
                        <section className="insurance-request-wizard-request-success__pdf-container">
                            {this.buildPdfViewer()}
                        </section>
                        <OKModal
                            content={modalContent}
                            contentOverflow="auto"
                            isOpen={this.state.showModal}
                            onCloseCallback={this.handleToggleModal}
                            size="large"
                        />
                    </WizardSuccess>
                </div>
            </div>
        );
    }
}

insuranceRequestWizardRequestSuccess.propTypes = {
    getDocument: PropTypes.func.isRequired,
    policyPdfBase64: PropTypes.string,
    policyPdfType: PropTypes.string,
    policyPdfName: PropTypes.string,
    productName:PropTypes.string,
    isRelated: PropTypes.bool,
    immInsuranceState: PropTypes.object,
    immInsuranceWizardState: PropTypes.object,
    immAccounts: PropTypes.object,
    hasSimulation: PropTypes.bool,
    hasSimulationChanged: PropTypes.bool,
};

module.exports = insuranceRequestWizardRequestSuccess;
